<template>
	<div class="wc-package-item" :class="{'field-error': !meta.valid || (value == 'osobno_preuzimanje' && !selectedLocation), 'shipping-disabled': parcel.shipping && parcel.shipping.selected?.disable_change_shipping}">
		<input :name="'shipping-' + parcel.number" :id="'field-shipping-' + parcel.number + '-' + data.id" :value="data.code" type="radio" @click="data.code == 'osobno_preuzimanje' ? selectLocation() : updateShippingItem()" v-model="value" />
		<label :for="'field-shipping-' + parcel.number + '-' + data.id">
			<span class="title">{{ data.title }}</span>
			<span class="info">
				<template v-if="data.preorder_package == true">predvidoma <BaseUtilsFormatDate :date="data.min_date" /></template>
				<template v-else-if="data.code == 'hitra_dostava'"><BaseCmsLabel code="wc_shipping_hitra_dostava_info" /></template>
				<template v-else>predvidoma od {{ formatDateLong(data.min_date) }} do {{ formatDateLong(data.max_date) }}</template>
			</span>
			<span v-if="data.code == 'osobno_preuzimanje'" class="location">
				<template v-if="parcel.shipping.pickup_location.selected">
					<strong>{{ parcel.shipping.pickup_location.selected.title }}</strong>
					<span class="location-btn"><BaseCmsLabel code="change" /></span>
				</template>
				<template v-else>
					<strong><BaseCmsLabel code="wc_shipping_location_empty" /></strong>
					<span class="location-btn"><BaseCmsLabel code="location_select" /></span>
				</template>
			</span>
			<div class="price-cnt">
				<template v-if="data.shipping_price > 0">
					<template v-if="data.discount_shipping_price != null && data.discount_shipping_price != data.shipping_price">
						<span class="price line-through"><BaseUtilsFormatCurrency :price="data.shipping_price" /></span>
						<span class="price price-new">
							<span class="red" v-if="data.discount_shipping_price > 0"><BaseUtilsFormatCurrency :price="data.discount_shipping_price" /></span>
							<span v-else class="green"><BaseCmsLabel code="free" /></span>
						</span>
					</template>
					<template v-else>
						<span class="price"><BaseUtilsFormatCurrency :price="data.shipping_price" /></span>
					</template>
				</template>
				<template v-else
					><span class="price green"><BaseCmsLabel code="free" /></span
				></template>
			</div>
		</label>
	</div>
</template>

<script setup>
	import {useField} from 'vee-validate';

	const webshop = useWebshop();
	const labels = useLabels();
	const {emit} = useEventBus();
	const props = defineProps(['data', 'parcel']);
	const { checkoutLoading, selectedShipping } = useCheckout();

	onMounted(() => {
		selectedShipping.value = props.parcel.shipping?.selected?.title;
	});

	//format date long
	function formatDateLong(value) {
		const d = new Date(value)
		const date = (d.getDate() < 9) ? '0' + d.getDate() : d.getDate()
		const day = d.getDay()
		const dayOfWeek = ['nedelje', 'ponedeljka', 'torka', 'srede', 'četrtka', 'petka', 'sobote']
		const month = (d.getMonth() < 9) ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)

		const dTomorrow = new Date()
		const dToday = new Date()
		let cday
		const tomorrow = dTomorrow
		const today = dToday
		tomorrow.setDate(dTomorrow.getDate() + 1)
		today.setDate(dToday.getDate())
		if (tomorrow.toDateString() === d.toDateString()) {
			cday = 'jutri'
		} else if (today.toDateString() === d.toDateString()) {
			cday = 'danes'
		} else {
			cday = dayOfWeek[day]
		}

		return cday + ', ' + date + '.' + month + '.'
	}

	// process input
	const {handleChange, value, meta, validate} = useField(
		'shipping-' + props.parcel.number,
		value => {
			if (!value || (value && value == 'osobno_preuzimanje' && !selectedLocation.value)) {
				return false;
			}
			return true;
		},
		{initialValue: props.parcel.shipping.selected ? props.parcel.shipping.selected.code : null}
	);

	// revalidate on shipping location update
	const selectedLocation = computed(() => {
		return props.parcel.shipping.pickup_location.selected ? props.parcel.shipping.pickup_location.selected : null;
	});

	//items shipping
	const itemsFastShipping = computed(() => {
		let value = false;

		if (props.parcel.items) {
			value = props.parcel.items.every(el => {
				return el.meta_data.available_shippings.some(shipping => shipping.code === 'hitra_dostava');
			});
		}

		return value;
	});

	watch(
		() => props.parcel.shipping,
		() => {
			value.value = props.parcel.shipping.selected ? props.parcel.shipping.selected.code : null;
			validate();
			selectedShipping.value = props.parcel.shipping?.selected?.title
		},
		{
			deep: true,
		}
	);

	// update shipping
	const shoppingCartCodes = computed(() => props.parcel.items.map(el => el.shopping_cart_code));
	const updateShippingItem = async () => {
		checkoutLoading.value = true;

		await webshop.updateShipping({
			shipping_id: props.data.id,
			shopping_cart_codes: shoppingCartCodes.value,
			shipping_data: {}
		});

		selectedShipping.value = props.data.title;

		checkoutLoading.value = false;
	};

	//locations flyout
	function selectLocation() {
		document.body.classList.add('flyout-page', 'cd-flyout-active');

		const locationData = props.parcel.shipping.pickup_location.available;
		const locationsGroup = locationData.reduce(function (r, a) {
			r[a.has_stock] = r[a.has_stock] || [];
			r[a.has_stock].push(a);
			return r;
		}, Object.create(null));

		let title = labels.get('step_shipping_choose_location');
		const content = {
			shippingTitle: props.data.title,
			shippingId: props.data.id,
			shoppingCartCodes: shoppingCartCodes,
			shippingLocations: locationsGroup,
			selectedLocation: props.parcel.shipping.pickup_location.selected,
			itemsFastShipping: itemsFastShipping,
		};


		emit('flyoutUpdate', {'flyout_mode': 'shipping_locations', 'flyout_title': title, 'flyout_content': content ? content : null});
	}
</script>

<style lang="less" scoped>
	.wc-package-item {
		display: flex;
		position: relative;
		&.shipping-disabled{
			pointer-events: none;
			input[type='radio'] + label {padding-left: 20px;}
			input[type='radio'] + label:before{content: none;}
			.location-btn{display: none;}
		}
		&.loading{
			pointer-events: none;
			&:before{content: ""; width: 40px; height: 40px; background: rgba(255, 255, 255, 0.3) url(assets/images/loader.svg) no-repeat center; background-size: 40px; position: absolute; top: 0; bottom: 0; left: 0; right: 0; z-index: 1;}
		}
		input[type='radio'] + label:before {
			top: 19px;
			left: 20px;
			@media (max-width: @m) {
				left: 15px;
				top: 16px;
			}
		}
		input[type='radio'] + label {
			padding: 20px 110px 20px 55px;
			border: 1px solid @borderColor;
			.transition(all);
			@media (max-width: @m) {
				padding: 15px 15px 15px 50px;
			}
		}
		input[type='radio']:checked + label {
			background: #ebf4ff;
			border-color: @blue;
			.title,
			.price:not(.green, .line-through) {
				color: @blue;
			}
		}
		.title {
			display: block;
			font-size: 15px;
			font-weight: 600;
			.transition(color);
			@media (max-width: @m) {
				padding-right: 90px;
			}
		}
		.info,
		.location {
			display: block;
			padding-top: 3px;
			font-size: 14px;
		}
		.info {
			@media (max-width: @m) {
				padding-right: 90px;
			}
		}
		.price-cnt {
			position: absolute;
			top: 20px;
			right: 20px;
			font-size: 15px;
			font-weight: 600;
			text-align: right;
			@media (max-width: @m) {
				top: 15px;
			}
		}
		.price {
			display: block;
		}
		.price-new {
			display: block;
			padding-top: 2px;
			color: @red!important;
		}
		.free {
			color: @lightGreen;
		}
		.location {
			display: inline-flex;
			justify-content: space-between;
			@media (max-width: @m) {
				display: flex;
				padding-top: 8px;
			}
		}
		.location-btn {
			flex-grow: 1;
			padding: 0 13px 0 20px;
			font-weight: 600;
			text-align: right;
			color: @blue;
			position: relative;
			&:after {
				.icon-arrow-down();
				font: 9px/1 @fonti;
				color: @blue;
				position: absolute;
				top: 6px;
				right: 0;
				.rotate(-90deg);
				.transition(right);
			}
			&:hover:after {
				right: -5px;
			}
		}

		&.field-error {
			input[type='radio'] + label {
				border-color: @red2;
			}
			.location {
				padding-top: 10px;
				font-size: 15px;
				position: relative;
				&:before {
					.icon-available-last();
					font: 18px/1 @fonti;
					color: @red2;
					position: absolute;
					top: 11px;
					left: -34px;
				}
			}
			.location-btn {
				font-size: 14px;
				color: @red2;
				text-decoration: underline;
				&:after {
					color: @red2;
				}
				&:hover {
					text-decoration: none;
				}
			}
		}
	}
</style>
